// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ErrorPage_wrapper__3kImQ","content":"ErrorPage_content__2hHIK","title":"ErrorPage_title__3Tauw components_pageTitle__B1wN3","button":"ErrorPage_button__3m9JL"};